export default __webpack_public_path__ + "static/media/06_03.b76bc086.jpg";